import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PodcastGroup } from '../../data/podcast-client-api/model/podcastContent';

@Injectable()
export class DataSharingService {

  private carouselID = new Subject<any>();
  private closeCarousel = new Subject<any>();
  private clearSearchQuery = new Subject<boolean>();
  private labelName = new Subject<string>();
  private setBool = new Subject<boolean>();

  constructor() { }
  
  carouselID$ = this.carouselID.asObservable();
  closeCarousel$ = this.closeCarousel.asObservable();
  clearSearchQuery$ = this.clearSearchQuery.asObservable();
  labelName$ = this.labelName.asObservable();
  setBool$ = this.setBool.asObservable();


  clearSearch(data: boolean) {
    this.clearSearchQuery.next(data);
  }

  sendCarouselID(data: any) {
    this.carouselID.next(data);
  }

  sendCloseCarouse(data: any) {
    this.closeCarousel.next(data);
  }
  
  sendLabelName(data: string) {
    this.labelName.next(data);
  }

  setBoolTrue(data: boolean) {
    this.setBool.next(data);
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/core/data-sharing/data-sharing.service.ts